// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1ui5g","resendInfoText":"OnGoingPaymentBox_resendInfoText__14gwL"};